import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["localeRadio", "bodyTextarea", "previewIframe", "channelRadio", "emailField", "whatsappField"]
  static values = {
    stockEn: String,
    stockEs: String,
    iframeEnSrc: String,
    iframeEsSrc: String,
  }

  connect() {
    this.updateChannel()
  }

  updateChannel() {
    const checked = this.channelRadioTargets.find((radio) => radio.checked)
    if (!checked) return

    const whatsapp = checked.value === "whatsapp"
    this.emailFieldTarget.hidden = whatsapp
    this.whatsappFieldTarget.hidden = !whatsapp
  }

  updateLocale() {
    const checked = this.localeRadioTargets.find((radio) => radio.checked)
    if (!checked) return

    if (checked.value === "en") {
      this.bodyTextareaTarget.value = this.stockEnValue
      this.previewIframeTarget.src = this.iframeEnSrcValue
    } else if (checked.value === "es") {
      this.bodyTextareaTarget.value = this.stockEsValue
      this.previewIframeTarget.src = this.iframeEsSrcValue
    }
  }
}
